module.exports = __webpack_public_path__ + "fontello.f3f961f9726036a94390.svg";


//////////////////
// WEBPACK FOOTER
// P:/Portfolio-angular-master/src/app/global-assets/fonts/font/fontello.svg?57799508
// module id = ../../../../../src/app/global-assets/fonts/font/fontello.svg?57799508
// module chunks = main